// We use 2 as there always will be bank + general documents
// (general documents configured inside dummy bank)
export const MIN_DOCUMENTS_BANKS_NUMBER = 1